module.exports = __webpack_public_path__ + "images/morenshezhi_red.svg";